import React, { useState } from 'react';
import { useBilling } from 'src/hooks/useBilling';
import { AnimatedDots } from '@components/shared/animated-dots/AnimatedDots';

export const BillingHistory = () => {
  const { invoices, isLoading, downloadBillingHistoryAsCSV } = useBilling();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = () => {
    setIsDownloading(true);
    try {
      downloadBillingHistoryAsCSV(invoices || []);
    } catch (error) {
      console.error('Failed to download billing history:', error);
      alert('Failed to download billing history. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  if (isLoading) {
    return (
      <section className="flex flex-col mt-1 rounded-3xl pb-6 bg-profile-section-bg">
        <div className="bg-profile-header-bg text-white flex justify-between items-center px-15 max-md:px-10 max-xs:px-5 max-md:pr-10 pr-14 rounded-t-3xl py-3.5 pb-2 max-md:py-5">
          <p className="text-[42px] max-md:text-3xl tracking-wide">
            Billing History
          </p>
        </div>
        <div className="flex justify-center items-center py-8">
          <div><AnimatedDots /></div>
        </div>
      </section>
    );
  }

  return (
    <section className="flex flex-col mt-1 rounded-3xl pb-6 bg-profile-section-bg">
      <div className="bg-profile-header-bg text-white flex justify-between items-center px-15 max-md:px-10 max-xs:px-5 max-md:pr-10 pr-14 rounded-t-3xl py-3.5 pb-2 max-md:py-5">
        <p className="text-[42px] max-md:text-3xl tracking-wide">
          Billing History
        </p>
        <button 
          onClick={handleDownload}
          disabled={isDownloading}
          className="uppercase flex items-center gap-7"
        >
          <p className="font-bold tracking-wider max-md:hidden">
            {isDownloading ? 'Downloading...' : 'Download Billing History'}
          </p>
          {/* <img src="/icons/download.png" className="w-7.5" alt="download-pen" /> */}
        </button>
      </div>
      <div className="flex flex-col px-14 mt-6 bg-profile-section-bg max-md:px-10 max-xs:px-5">
        <p className="text-xl tracking-[0.02em] max-w-[65%] max-l:max-w-full">
          Below is a listing of your payments and/or refunds. As always, should
          you have any questions about billing please fee free to reach our to
          us <button className="text-primary">here</button>.
        </p>
        <div className="mt-6 max-lg:overflow-x-auto border-t-2 font-secondary">
          <div className="min-w-200">
            <div className="grid grid-cols-[20%_38%_24%_20%] gap-2 p-5 pl-0 border-b-2">
              <span className="text-lg text-profile-date-text">Date</span>
              <span className="text-lg text-profile-text-muted">
                Description and Transaction ID
              </span>
              <span className="text-lg text-profile-text-muted">Product</span>
              <span className="text-lg text-profile-text-muted">Amount</span>
            </div>

            {invoices?.map((invoice) => (
              <div
                key={invoice.id}
                className="grid text-lg grid-cols-[20%_38%_24%_20%] gap-2 p-5 py-4 pl-0 border-b-2"
              >
                <span>{new Date(invoice.createdAt).toLocaleDateString()}</span>
                <span>Invoice #{invoice.id}</span>
                <span>{invoice.status}</span>
                <span>${invoice.amountDue.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>
{/* 
        <button className="text-primary uppercase mt-4 font-bold text-xl hover:text-primary/70">
          Show more
        </button> */}
      </div>
    </section>
  );
};
